import { Component, OnInit, ViewChild } from '@angular/core';

import { DoubleBounceComponent } from '../../../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../../../shared/custom-alert/custom-alert.component';

import { KairosViewModel } from '../../models/kairosViewModel'

import {KairosService} from '../../services/kairos.service'

@Component({
  selector: 'app-alta-kairos',
  templateUrl: './alta-kairos.component.html'
})
export class AltaKairosComponent implements OnInit {

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }  

  kairos: KairosViewModel = {
    nombre: "",
    tipo: 1,
    archivo: null  
  }

  tipoActualizacion: any=[
    {"descripcion" : "Actualizacion Diaria", "valor" :1},
    {"descripcion" : "Actualizacion Semanal", "valor" :2},
    {"descripcion" : "Base de datos completa", "valor" :3},
    {"descripcion" : "Microsoft Access", "valor" :4}
  ]
 

  @ViewChild('fileInput')  
  fileInput: any;

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  errores = new Array();

  constructor(private kairosService:KairosService) { }

  ngOnInit() {
    this.spinner.isRunning = false;
  }

  onChange(e: any) {    
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();        
    if(ext !== "zip"){
      alert("El formato del archivo no es válido");
    }else{
      this.kairos.archivo = file;
    }
  }


  onSubmit(){        
    this.spinner.isRunning = true;
    this.alert.visible = false;
    this.kairosService.guardar(this.kairos)
      .map(result => {
        this.alert.visible = true;
        this.alert.titulo = "Actualizacion Kairos";
        if (result.status == 201) {
          this.kairos = {
            nombre: "",
            tipo: 1,
            archivo: null  
          };
          this.fileInput.nativeElement.value = "";          
          this.alert.tipo = "success"
          this.alert.mensaje = "La actualizacion se ha guardado correctamente"
        } else {
          this.alert.tipo = "danger"
          this.alert.mensaje = "Los datos no se han podido guardar. Por favor vuelva a intentarlo."
        }        
        this.alertComponent.setType(this.alert.tipo);
        this.spinner.isRunning = false;
      })
      .subscribe(data => {

      }, error => {
        var json = error.json();        
        this.spinner.isRunning = false;
        this.alert.visible = true;
        this.alert.titulo = "Actualizacion Kairos";        
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
        this.alert.mensaje = "Los datos no se han podido guardar. Por favor vuelva a intentarlo."        
        if (json.modelState) {
          for (var key in json.modelState) {
            if (json.modelState[key].length == 1) {
              this.errores.push(json.modelState[key]);
            } else {
              for (var i = 0; i < json.modelState[key].length; i++) {
                this.errores.push(json.modelState[key][i]);
              }
            }
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/intranet/kairos/alta-kairos/alta-kairos.component.ts